import { createContext, useContext, useState } from 'react';
import useAPI from '../../hooks/integrations/useAPI';
import { API_BASE_URL } from '../../settings/constants';
import UrlBuilder from '../../utils/UrlBuilder';

const Context = createContext();

const Provider = ({ children }) => {
    const api = useAPI();
    const [selectedMachines, setSelectedMachines] = useState([]);

    const getPage = (offset, limit, sorter, _filters, options) => {
        const url = new UrlBuilder(`${API_BASE_URL}/instruments`);
        url.addPagination(offset, limit).addSorting(sorter);

        const filters = _filters.company_uuid && {
            companies: _filters.company_uuid?.map((uuid) => ({ uuid })),
        };

        if (!filters) {
            console.info('I2.API_GET :', url.toString());
            return api.makeRequest(
                {
                    url,
                    method: 'GET',
                },
                options
            );
        } else {
            console.info('I3.API_POST:', url.toString());
            return api.makeRequest(
                {
                    url,
                    method: 'POST',
                    data: JSON.stringify(filters),
                },
                options
            );
        }
    };

    const saveInstrument = (data) => {
        const url = `${API_BASE_URL}/instruments`;
        console.info('I3.API_PUT :', url.toString(), data);
        return api.makeRequest({
            url,
            method: 'PUT',
            data,
        });
    };

    return (
        <Context.Provider
            value={{
                selected: selectedMachines,
                getPage,
                setSelectedMachines,
                saveInstrument,
            }}
        >
            {children}
        </Context.Provider>
    );
};

export const useMachineCtx = () => {
    return useContext(Context);
};

export default Provider;
